// ABOUTME: Card component displaying a single game's summary info.
// ABOUTME: Used on Host and Play pages; links to the passed href on click.
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import PeopleIcon from '@mui/icons-material/People'
import { Link } from 'react-router'
import { type GameDto } from '../api/generated'
import { STATUS_LABEL, STATUS_COLOR } from './gameStatus'

interface Props {
  game: GameDto
  href: string
}

export function GameCard({ game, href }: Props) {
  return (
    <Card>
      <CardActionArea component={Link} to={href}>
        <CardContent>
          <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
              <Typography variant="h6">{game.title}</Typography>
              <Chip
                label={STATUS_LABEL[game.status]}
                color={STATUS_COLOR[game.status]}
                size="small"
              />
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {game.squarePack.title}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <PeopleIcon fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                {game.playerCount} {game.playerCount === 1 ? 'player' : 'players'}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
